const rqParams = {
  // 获取要跳转的列表
  getlistenspeakinfov2(param) {
    return {
      op_path: 'exercisebook.book.getlistenspeakinfov2',
      noJumpTo: true,
      ...param
    }
  },
  /**
   * @description 数据概览-教辅书-学习学生数和题目完成度
   * @param {*} param
   * @returns
   */
  getStudyRecordModelCountByBookId(param) {
    return {
      op_path:
        'yjstudyrecord.studyrecorddata.getstudyrecordmodelcountbybookid',
      noJumpTo: true,
      ...param
    }
  }
}
export default rqParams
